import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, HostBinding, input, output } from '@angular/core';

import { fadeInUp, fadeOutDown } from 'ng-animate';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-action-button-bar',
  templateUrl: './lex-xi-action-button-bar.component.html',
  styleUrls: ['./lex-xi-action-button-bar.component.scss'],
  animations: [
    trigger('animate', [
      transition(':enter', useAnimation(fadeInUp, { params: { timing: 0.3, delay: 0 } })),
      transition(':leave', useAnimation(fadeOutDown, { params: { timing: 0.3, delay: 0 } })),
    ]),
  ],
  standalone: false,
})
export class LexXiActionButtonBarComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly cancelDisabled = input<boolean>();
  readonly saveDisabled = input<boolean>();

  readonly cancelClicked = output();
  readonly saveClicked = output();

  @HostBinding('@animate') get enterLeave() {
    return true;
  }

  cancel() {
    this.cancelClicked.emit();
  }

  save() {
    this.saveClicked.emit();
  }
}
